import { render, staticRenderFns } from "./TwBookingHistory.vue?vue&type=template&id=785aeaf4&scoped=true&"
import script from "./TwBookingHistory.vue?vue&type=script&lang=js&"
export * from "./TwBookingHistory.vue?vue&type=script&lang=js&"
import style0 from "./TwBookingHistory.vue?vue&type=style&index=0&id=785aeaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785aeaf4",
  null
  
)

export default component.exports